import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canActivateTeam } from './auth/auth-gaurd';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  {
    path: ':domain',
    loadChildren: () =>
      import('./layout/layout.module').then((m) => m.LayoutModule),
    canActivate: [canActivateTeam],
  },
  {
    path: ':domain/sign-in',
    component: SignInComponent,
  },

  {
    path: ':domain/support',
    component: SignInComponent,
    canActivate: [canActivateTeam],
    data: {
      externalUrl: environment.supportUrl,
    },
  },

  {
    path: ':domain/auth-callback',
    redirectTo: 'ignite',
    pathMatch: 'full',
  },
  { path: '', redirectTo: 'ignite', pathMatch: 'full' },
  { path: '**', redirectTo: ':domain/not-found', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
